// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedPupillography_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.00003 3.99995 11 0H5L8.00003 3.99995ZM8 12 5 16 11 16 8 12ZM4.55958 2.74609C2.34215 3.74573.600487 5.66689 0 7.99995.600491 10.333 2.34218 12.2542 4.55963 13.2538L5.79392 11.6081C4.05429 10.9828 2.5863 9.65875 2 7.99995 2.5863 6.34117 4.05426 5.01717 5.79386 4.39181L4.55958 2.74609ZM10.2061 4.39185C11.9457 5.01723 13.4137 6.3412 14 7.99995 13.4137 9.65872 11.9457 10.9827 10.2061 11.6081L11.4403 13.2538C13.6578 12.2541 15.3995 10.333 16 7.99995 15.3995 5.66693 13.6578 3.74578 11.4404 2.74614L10.2061 4.39185Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11ZM8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 6 15 2H9L12 6ZM12 18 9 22H15L12 18ZM9.6834 6.24456C6.41425 6.9458 3.68457 9.10072 2.20291 12 3.68451 14.8992 6.41436 17.0541 9.68346 17.7554L8.38274 19.4897C4.58562 18.3912 1.50372 15.607 0 12 1.50376 8.39295 4.58552 5.60874 8.38267 4.51025L9.6834 6.24456ZM14.3166 6.24455C17.586 6.94576 20.3164 9.1007 21.7981 12 20.3163 14.8995 17.5861 17.0545 14.3167 17.7556L15.6174 19.4899C19.4146 18.3915 22.4962 15.6072 24 12 22.4962 8.39295 19.4145 5.60874 15.6173 4.51025L14.3166 6.24455Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedPupillography is a generated icon component.
 */
let IconMedPupillography = IconMedPupillography_1 = class IconMedPupillography extends IconBaseElement {
    render() {
        return html `${IconMedPupillography_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedPupillography.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedPupillography = IconMedPupillography_1 = __decorate([
    customElement('zui-icon-med-pupillography')
], IconMedPupillography);
export { IconMedPupillography };
